<template>
    <div class="top-line top-banner">
        <div class="logo"></div>
        <div class="left">
            <span>|</span>
            <router-link to="/">首页</router-link>
            <span v-if="validPriv('004')">|</span>
            <router-link to="/flow/shop/day" v-if="validPriv('004')">客流查询</router-link>
            <span v-if="validPriv('001')">|</span>
            <!-- <router-link to="/opearte/shop" v-if="validPriv('004')">经营分析</router-link>
            <span v-if="validPriv('001')">|</span> -->
            <router-link to="/platform/tenant" v-if="validPriv('001')">平台管理</router-link>
            <span v-if="validPriv('003')">|</span>
            <router-link to="/ops/flow" v-if="validPriv('003')">运维管理</router-link>
            <span v-if="validPriv('002')">|</span>
            <router-link to="/sys/entity" v-if="validPriv('002')">系统管理</router-link>
        </div>
        <div class="right">
            <div>
                <span>{{ userName }}</span>
                <a href="javascript:void(0);" @click="logout">退出</a>
            </div>
            <div>
                <img />
            </div>
        </div>
    </div>
</template>
<script>
import auth from "../../scripts/auth";
export default {
    name: "TopBanner",
    data() {
        return {
            userName: "",
        };
    },
    created() {
        this.userName = auth.getTokenData().User.UserName;
    },
    methods: {
        validPriv(code) {
            return auth.validPrivCodeBegin(code);
        },
        logout() {
            if (confirm("确定要退出吗？")) {
                auth.removeToken();
                window.location = "/";
                //this.$router.push({ path: '/' });
            }
        },
    },
};
</script>
